import {
  Drawer,
  DrawerBody,
  DrawerHeaderTitle,
} from "@fluentui/react-components";
import { Dispatch, PropsWithChildren, ReactNode, SetStateAction } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";

type PspDrawerProps = {
  title: ReactNode;
  subTitle?: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  position?: "end" | "start" | "bottom";
};

export function PspDrawer({
  children,
  title,
  subTitle,
  isOpen,
  onClose,
  position = "end",
}: PropsWithChildren<PspDrawerProps>) {
  return (
    <Drawer
      position={position}
      open={isOpen}
      onOpenChange={onClose} // hopefully this doesn't come back to bite me
      size="medium"
    >
      <div className="p-4 w-full">
        <DrawerHeaderTitle
          className="items-center flex flex-row"
          action={
            <button
              className="
                cursor-pointer
                group
                mt-1
                mr-2
                mb-auto
                flex
                flex-col
                justify-center
              "
              onClick={onClose}
            >
              <FontAwesomeIcon
                className="
                  text-xl
                  text-font-secondary
                  group-hover:text-font-black
                  duration-200
                "
                icon={faXmark}
              />
            </button>
          }
        >
          <div className="align-middle h-full flex flx-col justify-center">
            {title}
          </div>
        </DrawerHeaderTitle>

        {subTitle && <div className="pt-3">{subTitle}</div>}
      </div>

      <div className="bg-neutral h-px w-full" />

      <DrawerBody className="p-4!">{children}</DrawerBody>
    </Drawer>
  );
}
